export const STATUS_TYPE = {
    ERROR: "ERROR",
    SUCCESS: "SUCCESS"
}